require("./bootstrap");

import './filters/formatters';

import Vue from 'vue';

import Vuetify from "vuetify";

Vue.use(Vuetify);

//Fire for each new vue();
window.Fire = new Vue();


import "moment/locale/ru";
import "moment/locale/az";

//add translations
Vue.prototype.trans = (key) => {
    key = key.toString().toLowerCase();
    return _.get(window.trans, key, key);
};

//get current lang
Vue.prototype.getLang = () => {
    return window.lang;
};


Vue.component(
    "input-select",
    require("./components/FormFields/SelectComponent.vue").default
);

Vue.component(
    "multi-select",
    require("./components/FormFields/MultiSelectComponent.vue").default
);

Vue.component(
    "multi-selector",
    require("./components/FormFields/MultiSelector.vue").default
);

Vue.component(
    "checkbox",
    require("./components/FormFields/CheckboxComponent.vue").default
);
Vue.component(
    "v-phone-field",
    require("./components/FormFields/PhoneInputComponent.vue").default
);

Vue.component(
    "v-menu-expand",
    require("./components/Common/MenuComponent.vue").default
);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#0078CC",
                secondary: "#f45d22",
                danger: "#e0245e",
                success: "#16bf63",
                warning: "#ffad1e",
                dark: "#25333d",
            },
        },
    },
});


export const mainApp = {
    vuetify,
    data: {
        loading: false,
        toggle: [],
        fees: [],
    },
    computed: {
        feesPrice() {
            //maybe not used
            return this.fees.length
                ? this.fees.map((a) => a.price).reduce((a, b) => +a + +b, 0)
                : null;
        },
    },
    methods: {
        toggleFunction(data) {
            //maybe not used
            if (this.toggle.indexOf(data) === -1) {
                this.toggle.push(data);
            } else {
                const index = this.toggle.indexOf(data);
                if (index > -1) {
                    this.toggle.splice(index, 1);
                }
            }
        },
    },
}

